<ez-main-layout [landingpageConfig]="landingpageConfig" [theme]="Themes.NONE">
  <div class="block--centered success-info">
    <img class="icon-success" alt="Zuzahlung abgeschlossen" /><br />
    {{ landingpageConfig.organisation.customFields['insuranceInfoText'] | handlebars: landingpageConfig }}

    <p class="success-title">Zuzahlung abgeschlossen</p>
    <br />
    Vielen Dank für Ihre Zuzahlung!
    <br /><br />
    Die Bestätigung der Zuzahlung <br />
    erhalten Sie von uns per Post.
  </div>

  <div>
    <ez-contact
      [organisation]="landingpageConfig.organisation"
      teaserShort="Haben Sie noch Fragen?"
      phonePrefix="Rufen Sie uns gerne an: "
      subtitle="Kundenservice"
      withContactForm="false"
    ></ez-contact>
  </div>
</ez-main-layout>
